import { render, staticRenderFns } from "./RepertoryPrincipalList.vue?vue&type=template&id=13c6ffbe&scoped=true&"
import script from "./RepertoryPrincipalList.vue?vue&type=script&lang=js&"
export * from "./RepertoryPrincipalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c6ffbe",
  null
  
)

export default component.exports